<template>
  <div class="c-moduler">
    <div class="c-title">
      <span>{{ title }}</span>
    </div>
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'moduler',
  props: {
    title: {
      type: String
    }
  }
}
</script>
<style lang="scss" scoped>
.c-moduler {
  padding: 20px 0;
  line-height: 24px;
  height: 100%;

  .c-title {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 20px;

    span {
      padding-left: 16px;
    }

    &:before {
      content: '';
      display: inline-block;
      width: 4px;
      height: 18px;
      background-color: #4b77ee;
      transform: translateY(4px);
    }
  }
}
</style>
